import { render } from "./result-header.vue?vue&type=template&id=7c771b14&ts=true"
import script from "./result-header.vue?vue&type=script&lang=ts"
export * from "./result-header.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__